import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import {connect} from 'react-redux';
import {login, getLoggedInUser} from '../../actions/action_auth';
import {bindActionCreators} from 'redux';
import { addLocaleData, IntlProvider } from "react-intl";
import messages from "../../locale/index.js";
import en from "react-intl/locale-data/en";
import es from "react-intl/locale-data/es";
addLocaleData([...en, ...es]);
class PrivacyPolicy extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden"
    };
  }
  componentDidMount() {
    if(this.props.auth.loggedIn && localStorage.getItem('drughelp-token')) {
      this.props.history.push("/admin/dashboard");
    }
    this.props.getLoggedInUser();
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUpdate(nextProps){
    if(!this.props.auth.loggedIn && nextProps.auth.loggedIn) {
      this.props.history.push("/admin/dashboard");
    }
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  login = () => {
    const {email,password} = this.state;
    this.props.login({email,password});
  }

  handleChange = event => {
    this.setState({ [event.target.id]: event.target.value });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container} style={{paddingTop : "0px"}}>
        <GridContainer justify="center"  style={{margin: 'auto'}}>
          <GridItem xs={12} mx={4} my={2}>
          <div>
            <h2 style={{ color: "#233750", textAlign: "justify" }}> <strong>Drughelp.care {window.intl.formatMessage({id : "view.privacypolicy.privacypolicy"})}</strong></h2>
            
            <h4 style={{ color: "#233750", textAlign: "justify" }}>
              <strong>{window.intl.formatMessage({id : "view.privacypolicy.thisprivacypolicyiseffectiveforallusers.title"})}</strong>
            </h4>
            <p style={{ color: "#233750", textAlign: "justify" }} dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.privacypolicy.thisprivacypolicyiseffectiveforallusers.description"})}}>
            </p>

            <h4 style={{ color: "#233750", textAlign: "justify" }}>
              <strong>{window.intl.formatMessage({id : "view.privacypolicy.informationcollectedautomaticallywhenyouvisitthiswebsiteandhowweuseit.title"})}</strong>
            </h4>
            <p style={{ color: "#233750", textAlign: "justify" }} dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.privacypolicy.informationcollectedautomaticallywhenyouvisitthiswebsiteandhowweuseit.description"})}}>
            </p>

            <h4 style={{ color: "#233750", textAlign: "justify" }}>
              <strong>{window.intl.formatMessage({id : "view.privacypolicy.accesstoyourlocation.title"})}</strong>
            </h4>
            <p style={{ color: "#233750", textAlign: "justify" }} dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.privacypolicy.accesstoyourlocation.description"})}}>
            </p>

            <h4 style={{ color: "#233750", textAlign: "justify" }}>
              <strong>{window.intl.formatMessage({id : "view.privacypolicy.informationcollectedwhenyoucreateanagencyaccount.title"})}</strong>
            </h4>
            <p style={{ color: "#233750", textAlign: "justify" }} dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.privacypolicy.informationcollectedwhenyoucreateanagencyaccount.description"})}}>
            </p>

            <h4 style={{ color: "#233750", textAlign: "justify" }}>
              <strong>{window.intl.formatMessage({id : "view.privacypolicy.cookies.title"})}</strong>
            </h4>
            <p style={{ color: "#233750", textAlign: "justify" }} dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.privacypolicy.cookies.description"})}}>
            </p>

            <h4 style={{ color: "#233750", textAlign: "justify" }}>
              <strong>{window.intl.formatMessage({id : "view.privacypolicy.informationcollectedwhenyouemailus.title"})}</strong>
            </h4>
            <p style={{ color: "#233750", textAlign: "justify" }} dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.privacypolicy.informationcollectedwhenyouemailus.description"})}}>
            </p>

            <h4 style={{ color: "#233750", textAlign: "justify" }}>
              <strong>{window.intl.formatMessage({id : "view.privacypolicy.security.title"})}</strong>
            </h4>
            <p style={{ color: "#233750", textAlign: "justify" }} dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.privacypolicy.security.description"})}}>
            </p>

            <h4 style={{ color: "#233750", textAlign: "justify" }}>
              <strong>{window.intl.formatMessage({id : "view.privacypolicy.contact.title"})}</strong>
            </h4>
            <p style={{ color: "#233750", textAlign: "justify" }} dangerouslySetInnerHTML={{__html: window.intl.formatMessage({id : "view.privacypolicy.contact.description"})}}>
            </p>


          </div>
            </GridItem>
        </GridContainer>
      </div>
    );
  }
}

PrivacyPolicy.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
  return {
    ...state
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    login: bindActionCreators(login, dispatch),
    getLoggedInUser: bindActionCreators(getLoggedInUser, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(loginPageStyle)(PrivacyPolicy));
